import React from 'react'
// import ReactDOM from 'react-dom';
import { ProductDetailInfo } from './productDetailInfo';
import { DetailImg } from './detailImg';

export const HomePage = props => {
	const { appData } = props

	// const productDetailInfo = () => {
	// 	ReactDOM.render(<ProductDetailInfo appData={appData} />, document.getElementById('product-tiles'));
	// }

	const productDetailTitleBar = appData?.pagecontextdata?.find(data => data.contentType === "productDetailTitleBar")
	const productDetailImages = appData?.pagecontextdata?.find(data => data.contentType === "productImages")
	const productDetailInfo = appData?.pagecontextdata?.find(data => data.contentType === "productDetails")

	return (
		<>
			{
				productDetailTitleBar &&
				<div className="detail-bc-name p-2">
					<div>
						<ol className="breadcrumbs" aria-label="Breadcrumb" role="navigation">
							{
								appData?.servicedata?.productData?.homewardPathSegments?.length > 0 &&
								appData?.servicedata?.productData?.homewardPathSegments.map((breadcrumps, index) =>
									<li key={index}>{breadcrumps.url ? <a href={breadcrumps.url}>{breadcrumps.displayName}</a> : breadcrumps.displayName}</li>
								)
							}
						</ol>
					</div>
					<div className="h4 py-2">{appData?.servicedata?.productData?.displayName}</div>
				</div>
			}
			<div className="detail-container">
				{productDetailImages && 
					<div className="detail-image">
						<DetailImg appData={appData} />
					</div>
				}
				{productDetailInfo && 
					<div className="detail-info px-2">
						<ProductDetailInfo appData={appData} />
					</div>
				}
				{/* {productDetailInfo()} */}
			</div>
			
		</>
	)
}
